import { TextAreaInput } from "@jugl-web/ui-components/cross-platform/forms/TextAreaInput";
import { useTranslations } from "@jugl-web/utils";
import { useInvoicesItemFormPageContext } from "@web-src/modules/invoices/pages/InvoicesItemFormPage/context/useInvoicesItemFormPageContext";

export const AdditionalNoteForm = () => {
  const { t } = useTranslations();
  const { register, errors } = useInvoicesItemFormPageContext();

  return (
    <div className="relative w-full max-w-3xl">
      <TextAreaInput
        label={t({
          id: "invoices.settings.businessInformation.notes",
          defaultMessage: "Additional notes",
        })}
        {...register("notes", {
          maxLength: {
            value: 1000,
            message: t({
              id: "invoices.settings.businessInformation.notes.maxLength",
              defaultMessage: "Additional notes cannot exceed 1000 characters",
            }),
          },
        })}
        maxLength={1000}
        lengthIndicator={{
          max: 1000,
        }}
        isInvalid={!!errors.notes?.message}
        errorMessage={errors.notes?.message}
        classNames={{
          inputWrapperClassName: "h-32 w-full",
          inputClassName:
            "min-h-full max-h-full jugl__custom-scrollbar overflow-y-auto",
        }}
      />
    </div>
  );
};
